import React, {Component} from 'react';
import {getGlobalError} from '../errors';
import Alert from '../../../ui/Alert';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

export class GlobalError extends Component {
    static propTypes = {
        error: PropTypes.any,
    };

    render() {
        const {error} = this.props;

        if (!error) {
            return null;
        }

        return (
            <Alert type='danger'>
                <FormattedMessage id='frontend.errors.global'/>
                &nbsp;
                <a href=''>
                    <FormattedMessage id='frontend.errors.try_again'/>
                </a>
            </Alert>
        );
    }
}

export default connect((state) => ({
    error: getGlobalError(state),
}))(GlobalError);
